import moment from "moment"

const exposureSearcher = (entity, exposed) => {
  const entityStartAt = moment.parseZone(entity.startAt)
  const entityEndAt = moment.parseZone(entity.endAt)
  const exposedStartAt = moment.parseZone(exposed.entryAt)
  const exposedEndAt = moment.parseZone(exposed.exitAt)
  if (entityStartAt.isSameOrAfter(exposedEndAt)) {
    // entity visit started after the exposed user started visiting the location
    // and started after the exposed user ended visiting the location
    return 1
  } else if (moment.parseZone(entityEndAt).isSameOrBefore(exposedStartAt)) {
    // entity visit started and finished before exposed user visited the location
    return -1
  } else {
    // entity visit started before the exposed user visited the location but did not *end* before
    // the exposed user visited the location
    return 0
  }
}

export { exposureSearcher }
